<div class="assign-wrapper">

  <p>
    Bitte wählen Sie die Mitarbeiter aus, die diesem Ticket zugewiesen werden sollen. Außerdem können Sie die Ticketart anpassen, falls diese nicht korrekt ist.
  </p>

  <label>Mitarbeiter auswählen (pflicht)</label>

  <assign-employees #assignEmployees [(selectedEmployeeIds)]="selectedEmployeeIds"></assign-employees>
</div>

<div class="assign-wrapper">
  <label>Ticketart</label>
  <afs-input-select [options]="ticketTypes" placeholder="Ticketart..." [showFilter]="true" [bindOnlyValue]="true" [(ngModel)]="selectedTicketType" backdropClass="backdrop"></afs-input-select>
</div>